import { render } from "./shvip.vue?vue&type=template&id=2bc29f67&scoped=true"
import script from "./shvip.vue?vue&type=script&lang=js"
export * from "./shvip.vue?vue&type=script&lang=js"

import "./shvip.vue?vue&type=style&index=0&id=2bc29f67&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc29f67"]])

export default __exports__